import { useProfile } from "../../../shared/hooks/useProfile";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import ProfileCard from "../components/ProfileCard";

export default function MyProfile() {
  const { profile, isLoading, error, refetch } = useProfile({
    include: ["tests"],
    staleTime: 0, // Always fetch fresh data
    refetchOnWindowFocus: true, // Refetch when window gains focus
  });

  return (
    <AuthenticatedLayout isLoading={isLoading} error={error}>
      <ProfileCard profile={profile} onRefresh={refetch} />
    </AuthenticatedLayout>
  );
}
